import { red } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

// A custom theme for this app
const theme = createTheme({
    typography: {
        // Defined in index.css
        fontFamily: "var(--font-family)",
    },
    components: {
        MUIDataTableFilter: {
            styleOverrides: {
                root: {
                    width: "800px",
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    justifyContent: "center"
                }
            }
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    textAlign: "center",
                    fontSize: "1.875rem",
                    lineHeight: "2.25rem",
                    fontWeight: 400,
                },
            },
        },
        MuiDialog: {
            defaultProps: {
                // The window itself doesn't scroll (only the content area in App.js does), so there's
                // nothing to lock - and the lock's padding shifts the layout to the left
                disableScrollLock: true,
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    "& .MuiButton-root": {
                        textTransform: "none",
                        minWidth: 0,
                        justifyContent: "flex-start",
                    },
                },
            },
        },
    },
    palette: {
        primary: {
            main: "#556cd6",
        },
        secondary: {
            main: "#00B4D8",
        },
        // error: {
        //     main: red.A400,
        // },
    },
});

export default theme;
